import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "You don't need tests",
  "description": "",
  "published": "2016-10-06T00:00:00.000Z",
  "redirect_from": ["/blog/dont-need-tests/swizec/7095"],
  "categories": "Opinions, Personal, QA, tests",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/10/photo-1461632830798-3adb3034e4c8-1024x684.jpeg",
        "alt": "photo-1461632830798-3adb3034e4c8"
      }}></img></p>
    <p>{`Unit tests are pointless. Integration tests are hard. Clicky tests are king.`}</p>
    <p>{`You write a piece of code, and you `}<em parentName="p">{`know`}</em>{` it works. You just wrote it. You just ran it. You just saw it do everything you thought to try. Any unit or integration tests would have confirmed this.`}</p>
    <p>{`Your PM gets your code and tries it out. He or she finds a bunch of things you forgot. Bits of the spec that you missed, nuances in edge cases you didn't think of, strange things even the PM didn't think of.`}</p>
    <p>{`The designer finds a bunch of crap that should've been obvious, but you're not a designer, so you didn't think it was obvious.`}</p>
    <p>{`You get back to your code. Any tests you would have written wouldn't have caught any of this stuff. You didn't think of it, so you wouldn't have written a test. Even if you did assume you aren't perfect and needed tests. You don't need tests.`}</p>
    <p>{`You fix the things. You test the things. Sometimes, you test something twice because you notice fixing it broke something else. Keeping all the balls in the air is annoying, but totally doable. You don't need tests.`}</p>
    <p>{`Your PM says ??. Your designer says gorgeous.`}</p>
    <p>{`Your QA team gets the code. You tell them which manual test cases to do. It takes them half a day, but your code is good. You don't need tests.`}</p>
    <p>{`Your user gets your code. It breaks. They did a thing that you didn't think to try, your PM didn't think was related, and nobody told QA to try.`}</p>
    <p>{`Your user is nice enough to file a Usersnap report.`}</p>
    <p><em parentName="p">{`"Nonsense"`}</em>{`, you say, `}<em parentName="p">{`"one in a million case. I can't reproduce that."`}</em></p>
    <p>{`Five more users find the bug. You notice a pattern. Your PM says this is now a production issue and should be fixed immediately.`}</p>
    <p>{`You drop everything you were doing. You fix the thing. You test the thing. Sometimes you test something twice because you notice fixing it broke something else. Keeping all the balls in the air is annoying, but totally doable. You don't need tests.`}</p>
    <p>{`Your PM says ??. You add a line item to QA's plate. It takes them half a day to test everything. QA says ??. Your code goes to production.`}</p>
    <p>{`Your users say nothing. Quiet users are good users. You don't need tests.`}</p>
    <p>{`Six months pass.`}</p>
    <p>{`It is time to refactor your code. You would kill for some tests.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      